<template>
  <div>
    <LoginOrPayView v-if="!isVip" vip-text="升级版本权益后<br/>即可查看更多商品销售详情数据分析"/>
    <div class="goods-anchor carrier-list-data"  v-if="isVip">
      <router-link :to="`/anchor/${$_.get(item, 'anchor.id')}`" v-for="(item, index) in info" :key="index"
        class="item-default">
        <div class="commodity-sort">{{index+1}}</div>
        <div class="item-icon icon-radius">
          <img :src="$_.get(item, 'anchor.avatar')" >
        </div>
        <div class="center-anchor-goods">
          <div class="item-name">{{$_.get(item, 'anchor.name')}}</div>
          <div class="item-fans">{{$retainWan($_.get(item, 'anchor.fans'))}}</div>
          <div class="item-tag-contain">
            <div class="default-tag" v-for="(tag, index) in $_.get(item, 'tag')" :key="index">{{tag}}</div>
          </div>
        </div>
        <div class="data-for-detail">
          <div class="data-title">关联销售额</div>
          <div class="data-number data-number-red">¥{{$retainWan($_.get(item, 'sales'))}}</div>
          <div class="data-title data-title-sec">关联销量</div>
          <div class="data-number">{{$retainWan($_.get(item, 'salesVolume'))}}</div>
        </div>
      </router-link>
    </div>
    <NoneData v-if="info && info.length===0 && isVip" style="margin-top: 1rem" />
  </div>
</template>

<script>
  export default {
    props: {
      params:{ type:Object, default: () => ({}) },
      title:{ type:Number, default:0 }
    },
    watch:{
      params:{
        deep:true,
        handler(){
          this.getData()
        }
      },
      title(){
        this.getData()
      },
    },
    mounted() {
      this.getData()
    },
    data:() => ({
      info:[]
    }),
    methods:{
      async getData(){
        if(this.$props.title !== 1 || !this.isVip){ return }
        this.$showLoading();
        const res = await this.$api.get(`v2/commodity/${this.$route.params.id}/anchorSales`,{params:this.$props.params}).catch(_=> ({data:[]}))
        this.info = res.data || []
        this.$toast.clear();
      },
    },
    computed:{
      isVip: ( that = this ) => ( that.$store.state.userLevel && that.$store.state.userLevel <= 96 )
    }
  }
</script>

<style lang="less" scoped>
  .goods-anchor {
    .near-days-anchor-sell {
      text-align: center;
      line-height: 0.8rem;
      height: 0.8rem;
      color: #a1aebf;
      font-size: .28rem;
      background: #fff;
      margin-bottom: 0.1rem;
    }
  }
</style>